export default "__VITE_ASSET__DZdbAGaQ__"